// ── 매출 관리 묶음(배치) 삭제·CSV 내려받기 ── useRevenue.js 가 339줄이라 떼어냈다(2026-11-05, 300줄 규칙, 동작 변화 없음)
import { apiClient } from '../../../api/apiClient';

export function useRevenueBatchActions({ apiBase, showToast, loadCardBatches, loadCardApps, loadTaxInvoices, loadInvoices }) {
  // ── 배치 삭제/다운로드 핸들러 ─────────────────────────────────────────────

  /** 카드승인 배치 삭제 */
  async function handleCardBatchDelete(batchId) {
    if (!window.confirm('이 배치와 해당 배치로 추가된 카드승인 내역을 삭제하시겠습니까?')) return;
    const r = await apiClient.del(`${apiBase}/card-batches/${batchId}`);
    if (r.data?.success) {
      showToast('배치가 삭제됐습니다.', 'success');
      loadCardBatches(); loadCardApps();
    } else showToast(r.data?.message || '삭제 실패', 'error');
  }

  /** 세금계산서 배치 삭제 */
  async function handleTaxBatchDelete(batchId) {
    if (!window.confirm('이 배치와 해당 배치로 등록된 세금계산서를 삭제하시겠습니까?')) return;
    const r = await apiClient.del(`${apiBase}/tax-invoice-batches/${batchId}`);
    if (r.data?.success) {
      showToast('배치가 삭제됐습니다.', 'success');
      loadTaxInvoices(); loadInvoices();
    } else showToast(r.data?.message || '삭제 실패', 'error');
  }

  /** CSV 다운로드 트리거 (Blob → 링크 클릭)
   *  ※ 서버가 보낸 UTF-8 BOM(EF BB BF)이 response.text()에 의해 제거되므로,
   *     프론트에서 항상 BOM을 다시 붙여야 Excel이 한글을 정상 인식함 */
  function triggerCsvDownload(csvText, fileName) {
    const clean = (csvText || '').replace(/^\uFEFF/, ''); // 혹시 남아있는 BOM 제거 후
    const blob = new Blob(['\uFEFF' + clean], { type: 'text/csv;charset=utf-8' }); // BOM 재삽입
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = (fileName || 'download').replace(/\.[^.]+$/, '') + '.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  /** 카드승인 배치 CSV 다운로드 */
  async function handleCardBatchDownload(batchId, fileName) {
    const res = await apiClient.get(`${apiBase}/card-batches/${batchId}/download`);
    if (!res.ok) {
      showToast(typeof res.data === 'string' ? res.data : (res.data?.message || '다운로드 실패'), 'error');
      return;
    }
    triggerCsvDownload(res.data, fileName || `card_batch_${batchId}`);
  }

  /** 세금계산서 배치 CSV 다운로드 */
  async function handleTaxBatchDownload(batchId, fileName) {
    const res = await apiClient.get(`${apiBase}/tax-invoice-batches/${batchId}/download`);
    if (!res.ok) {
      showToast(typeof res.data === 'string' ? res.data : (res.data?.message || '다운로드 실패'), 'error');
      return;
    }
    triggerCsvDownload(res.data, fileName || `invoice_batch_${batchId}`);
  }

  return { handleCardBatchDelete, handleTaxBatchDelete, handleCardBatchDownload, handleTaxBatchDownload };
}
